import { TChatKitConstants, TTranslationFunction } from '../_lib/types'

/**
 * Get localized ChatKit constants for Business Naming Agent
 * @param t - Translation function from useTranslations('business-naming-agent')
 * @returns Localized ChatKit constants
 */
export function getChatKitConstants(
  t: TTranslationFunction,
): TChatKitConstants {
  return {
    greeting: t('chatkit_greeting'),
    starterPrompts: [],
    placeholder: t('chatkit_placeholder'),
  }
}
